import * as types from './types';

const initialState = {
  phones: null,
  data: null,
  id: null,
  loading: false,
  success: false,
  fetchUserPhoneCheckError: false,
  isModifiable: true,
  fetchUserisModifiableError: false,
  counter: 0
};

function userPhoneCheckReducer(state = initialState, action) {
  switch (action.type) {
    case types.USER_PHONE_SET_COUNTER:
      return {
        ...state,
        counter: action.meta.counter
      };

    case types.USER_PHONE_CHECK:
      return {
        ...state,
        loading: true,
        phone: action.meta.phone
        // data: { ...state.data, [action.meta.id]: action.meta.data },
      };

    case types.USER_PHONE_CHECK_COMPLETED:
      return {
        ...state,
        loading: false,
        phones: { ...state.phones, [action.meta.id]: action.payload },
        success: true,
        fetchUserPhoneCheckError: false,
        counter: state.counter - 1
      };

    case types.USER_PHONE_CHECK_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        phones: { ...state.phones, [action.meta.id]: { error: true } },
        result: { ...action.payload },
        fetchUserPhoneCheckError: true,
        counter: state.counter - 1
      };

    case types.USER_CHECK_ABLE_MODIFY:
      return {
        ...state,
        loading: true,
        phone: action.meta.phone,
        id: action.meta.id
      };

    case types.USER_CHECK_ABLE_MODIFY_COMPLETED:
      return {
        ...state,
        loading: false,
        isModifiable: action.payload.valid,
        success: true
      };

    case types.USER_CHECK_ABLE_MODIFY_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        result: { ...action.payload },
        fetchUserisModifiableError: true
      };

    case types.USER_PHONE_CHECK_RESET:
      return {
        ...state,
        success: false,
        result: null,
        phones: null,
        data: null,
        fetchUserPhoneCheckError: false,
        fetchUserisModifiableError: false,
        counter: -1
      };

    default:
      return state;
  }
}

export default userPhoneCheckReducer;
